import React from 'react';

type CallParams = {
  data: any;
};

const DeviceRow = (props: CallParams) => {
  const requestTypeIndicator = props.data.isEmergency ? '!' : '';
  const callLogStatusColor = props.data.wasAnswered ? '' : 'txt-red';

  const participantList = props.data.participantsText;

  return (
    <tr>
      <td className="nucleus-row">{props.data.startTime}</td>
      <td className={'nucleus-row left-align '}>{props.data.callType}</td>
      <td className={'nucleus-row left-align ' + callLogStatusColor}>{props.data.status}</td>
      <td className="nucleus-row left-align">{props.data.duration}</td>
      <td className="nucleus-row left-align">{participantList}</td>
      <td className="nucleus-row left-align">{props.data.notes}</td>
      <td className="nucleus-row center-align">
        <span className={'txt-red nucleus-font-family-big'}>
          <b>{requestTypeIndicator}</b>
        </span>
      </td>
    </tr>
  );
};

export default DeviceRow;
